import type { JSX } from "react";

export function CardFill(): JSX.Element {
  return <span aria-hidden data-part="fill" className="site-fill" />;
}
